import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import styles from './heading-list-item.scss.js';
import childrenStyles from './children.scss.js';
/**
 * @element cipublic-heading-list-item
 */
export class HeadingListItem extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * Heading list color.
         */
        this.color = 'primary';
        this.emitConnectedCallback = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
        // gives enough time for children to be defined
        this.initialChildren = Array.from(this.children).filter((element) => {
            return !(element.nodeName === 'SLOT') && !element.slot;
        });
    }
    firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        addStyleSheetToElements(this.initialChildren, childrenStyles);
    }
    render() {
        return html `<li><div class="counter"></div><slot></slot></li>`;
    }
}
HeadingListItem.styles = styles;
__decorate([
    property({ reflect: true })
], HeadingListItem.prototype, "color", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], HeadingListItem.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=heading-list-item.js.map